/**
 * Get size of Bytes3 (always 3)
 *
 * @param {import('./Bytes3Type.js').Bytes3Type} _bytes - Bytes3
 * @returns {3} Size (always 3)
 *
 * @example
 * ```typescript
 * const size = Bytes3.size(bytes); // 3
 * ```
 */
export function size(_bytes) {
	return 3;
}
